var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n    ")),React.createElement("g",{"id":"Icon_feather-arrow-right","data-name":"Icon feather-arrow-right","transform":"translate(-5.5 -20.611)","key":1},[React.createElement("path",{"id":"Path_102","data-name":"Path 102","className":"cls-1","d":"M7.5,18H70.414","transform":"translate(0 20.957)","key":0}),React.createElement("path",{"id":"Path_103","data-name":"Path 103","className":"cls-1","d":"M18,7.5,33.517,23.017,18,38.534","transform":"translate(39.927 15.94)","key":1})])]);
}

Arrow.defaultProps = {"width":"69.944","height":"36.691","viewBox":"0 0 69.944 36.691"};

module.exports = Arrow;

Arrow.default = Arrow;
